<div class="overflow-hidden rounded-lg border border-custom-bg-gray-1">
  <table class="min-w-full border-collapse-separate border-spacing-0 w-full">
    <thead class="bg-custom-bg-gray-1">
    <tr>
      <th class="p-2 border-b border-r text-left font-medium">Склад</th>
      <th class="p-2 border-b border-r text-center font-medium">Наличие</th>
      <th class="p-2 border-b border-r text-center font-medium">Кол-во</th>
      <th class="p-2 border-b text-center font-normal"> </th>
    </tr>
    </thead>
    <tbody>
      @for (product of products(); track product.id; let i = $index) {
        <tr class="border-b">
          <td class="p-2 border-r w-[228px] text-left">{{ product.storeName }}</td>
          <td class="p-2 border-r text-center">{{ product.count | productCount }}</td>
          <td class="p-2 border-r text-center">
            <app-numeric-up-down
              [value]="getQuantity(product, i)"
              (valueChange)="setQuantity(product, i, $event)"
              [max]="product.count">
            </app-numeric-up-down>
          </td>
          <td class="p-2 text-center">
            <button
              class="bg-custom-red text-white px-4 py-1 rounded hover:bg-white hover:text-custom-red border border-custom-red transition"
              (click)="addToCart(product, i)">
              В корзину
            </button>
          </td>
        </tr>
      }

    </tbody>
  </table>
</div>
